module.exports = __webpack_public_path__ + "static/media/sph706_logo.cc971276.png";